import { FullPolicy } from '../../services/api';
import { SchemeType } from '../../services/interface/Shared';
import { IFullPolicyState } from '../../store/fullPolicy.slice';

/**
 * Transforms API FullPolicy response to client-side IFullPolicyState
 * Handles type casting for scheme property from string to SchemeType
 */
const transformFullPolicyToState = (apiPolicy: FullPolicy): IFullPolicyState => {
	const { scheme, ...rest } = apiPolicy;
	return {
		...rest,
		scheme: scheme as SchemeType | undefined,
	};
};

export default transformFullPolicyToState;
